import { Component, OnInit, Input,HostListener } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { DataService } from 'src/app/services/data.service';

@Component({
  selector: 'app-attributes-add-img',
  templateUrl: './attributes-add-img.component.html',
  styleUrls: ['./attributes-add-img.component.scss'],
})
export class AttributesAddImgComponent implements OnInit {

  @Input() product_info;
  alert  = false;
  alert_msg;
  selected_attr_id;

  constructor(public db:DataService,public modalCtrl:ModalController) { }

  ngOnInit() {
    // console.log(this.product_info);
    if(this.product_info){
      // localStorage.product_images = (this.product_info.product_images && this.product_info.product_images.length != 0) ? JSON.stringify(this.product_info.product_images) : [];
      // this.product_info.product_attributes = this.product_info.product_attributes.filter(res=>res.options.length !== 0)
      // this.product_info.selected_attr = this.product_info.product_attributes[0];
      if(this.product_info.selected_attr){
        this.product_info.selected_attr = this.product_info.selected_attr;
        this.selected_attr_id = this.product_info.selected_attr.product_attribute;
        this.check_get_images();
      }else{
        this.product_info.selected_attr = this.product_info.product_attributes[0];
        this.selected_attr_id = this.product_info.product_attributes[0].product_attribute;
        this.get_images();
      }
      
    }

    const modalState = {
      modal : true,
      desc : 'fake state for our modal'
    };
    history.pushState(modalState, '');

  }


  @HostListener('window:popstate', ['$event'])
  dismissModal() {
    this.modalCtrl.dismiss();
  }

  check_get_images(){
    if(this.product_info.selected_attr.options && this.product_info.selected_attr.options.length != 0){
      this.product_info.selected_attr.options.map((res,i)=>{
        if(res['image_list'] && res['image_list'].length == 0){
          res['image_list'] = JSON.parse(JSON.stringify(this.product_info.product_images));
        }
      })
    }
  }

  get_images(){
    // let images =  JSON.parse(localStorage.product_images);
    if(this.product_info.selected_attr.options && this.product_info.selected_attr.options.length != 0){
      this.product_info.selected_attr.options.map((res,i)=>{
         res['image_list'] = JSON.parse(JSON.stringify(this.product_info.product_images));
      })
    }
  }
  

  value_changed(event,product_info){
    let data = event.target.value;
    // console.log(data);
    product_info.selected_attr = product_info.product_attributes.find(res=>res.product_attribute == data)
    let filter = product_info.product_attributes.filter(res=>res.product_attribute !== data)
    filter.map(res=>{
      res.options.map(r=>{r.image_list = []})
    })
    this.get_images();
    this.alert = true;
    this.alert_msg = 'Selected  images are deleted can set a images only form one attributes';
    setTimeout(()=>{this.alert = false},1800);
  }

  save_data(product_info){
    // console.log(product_info)
    product_info.selected_attr.options.map(res=>{
      res.image_list = res.image_list.filter(r=>r.check == true);
    })
    this.modalCtrl.dismiss();
  }
  
}
